import { render } from "./TicketAttachmentFileDownloader.vue?vue&type=template&id=64ef7d43"
import script from "./TicketAttachmentFileDownloader.vue?vue&type=script&lang=js"
export * from "./TicketAttachmentFileDownloader.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__